
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gtDsfkWZekOX_7tosq659TIahZJK5hF2YoCqWChr863sMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexpFBa6ybxd_u4q6MrVwjTtQntRlHU1c_YV0W8Dp6rOE0Meta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search4WJBS_45xdn8F0_45bcGLAgmvLhHY6NK3tK1oGEHHXmjCSEMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexPuYpuyoMPHyZNR7iftHJnaaVoXbQR17bdnZgNLlvqWMMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Lv_45aHszbz9VOoBaYEck6RmyJ27l1wceDYCC5Irri1IAMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexxuoqcqG7vaBQsacrJXlZJm_45g5_45d2AMz2_lJWafOEVzYMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_uTgDqEVNtOgYo9eIA7fbbJnLM_sKT_45afVaovRihKCoMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index_wDY5uYPZX3lh_45kmsM5mgvC6msbyIurF_45GQZUf5vxOAMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93_45LFVMsLEmoRiY4BAiDONz0wDERJJsQgWSrz9GIAhwMEMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexSClLmQpHgBhcmhizMQztBd4HIDD3RiMAx23NjGYqMl8Meta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexuvz4xFHSXqKm6llY_45Yal4ba3yl9H80TBVN_45IYEP1N1gMeta } from "/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexxuoqcqG7vaBQsacrJXlZJm_45g5_45d2AMz2_lJWafOEVzYMeta || {},
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index_wDY5uYPZX3lh_45kmsM5mgvC6msbyIurF_45GQZUf5vxOAMeta || {},
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexSClLmQpHgBhcmhizMQztBd4HIDD3RiMAx23NjGYqMl8Meta || {},
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexuvz4xFHSXqKm6llY_45Yal4ba3yl9H80TBVN_45IYEP1N1gMeta || {},
    component: () => import("/codebuild/output/src4135350090/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]